import { ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  count: number;
  className?: string;
};

export const RequestVoteCount = ({ count, className }: Props) => {
  return (
    <div className={cn('flex w-[36px] flex-col items-center justify-center', className)}>
      <ChevronUp className="text-lime-600 drop-shadow-[0_0_2px_rgba(163,230,53,1)] dark:text-lime-400" />
      {count}
    </div>
  );
};
